/**
 * @fileOverview This file contains the implementation of the MoreInfoDialog component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region  Imports
import {
  Popover,
  Grid,
  Typography,
  Paper,
  List,
  ListItem,
  Box,
} from '@mui/material';

import '../../scss/Components/MaintenanceAgenda/_infodialog.scss';
//#endregion

const MoreInfoDialog = ({ open, anchor, close }) => {
  return (
    <Popover
      id="agenda-popover"
      open={open}
      sx={{
        pointerEvents: 'none',
      }}
      anchorEl={anchor}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={close}
      disableRestoreFocus
    >
      <Grid className="dialog-container" container padding={1.5}>
        <Grid item xs={6}>
          <Paper
            sx={{
              height: '100%',
              boxShadow: 'none',
            }}
          >
            <Typography className="legend-title">
              Leyenda de prioridades
            </Typography>
            <List dense={true}>
              <ListItem sx={{ gap: 1 }} disableGutters>
                <Box
                  sx={{
                    width: '55px',
                    height: '15px',
                    borderRadius: '10px',
                    backgroundColor: '#FFCECE',
                  }}
                ></Box>
                <Typography className="legend-label">Prioridad alta</Typography>
              </ListItem>
              <ListItem sx={{ gap: 1 }} disableGutters>
                <Box
                  sx={{
                    width: '55px',
                    height: '15px',
                    borderRadius: '10px',
                    backgroundColor: '#FFEEB0',
                  }}
                ></Box>

                <Typography className="legend-label">
                  Prioridad media
                </Typography>
              </ListItem>
              <ListItem sx={{ gap: 1 }} disableGutters>
                <Box
                  sx={{
                    width: '55px',
                    height: '15px',
                    borderRadius: '10px',
                    backgroundColor: '#C8FFBF',
                  }}
                ></Box>

                <Typography className="legend-label">Prioridad baja</Typography>
              </ListItem>
            </List>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ height: '100%', boxShadow: 'none' }}>
            <Typography className="legend-title">
              Leyenda de mantenimientos
            </Typography>
            <List dense={true}>
              <ListItem sx={{ gap: 3 }} disableGutters>
                <Typography
                  className="legend-label letter"
                  sx={{ color: '#5288DA' }}
                >
                  M
                </Typography>
                <Typography className="legend-label">Mensual</Typography>
              </ListItem>
              <ListItem sx={{ gap: 3 }} disableGutters>
                <Typography
                  className="legend-label letter"
                  sx={{ color: '#FF3A8D' }}
                >
                  T
                </Typography>
                <Typography className="legend-label">Trimestral</Typography>
              </ListItem>
              <ListItem sx={{ gap: 3 }} disableGutters>
                <Typography
                  className="legend-label letter"
                  sx={{ color: '#F88318' }}
                >
                  S
                </Typography>
                <Typography className="legend-label">Semestral</Typography>
              </ListItem>
              <ListItem sx={{ gap: 3 }} disableGutters>
                <Typography
                  className="legend-label letter"
                  sx={{ color: '#8E44AD' }}
                >
                  B
                </Typography>
                <Typography className="legend-label">Bimestral</Typography>
              </ListItem>
              <ListItem sx={{ gap: 3 }} disableGutters>
                <Typography
                  className="legend-label letter"
                  sx={{ color: '#16A085' }}
                >
                  C
                </Typography>
                <Typography className="legend-label">Cuatrimestral</Typography>
              </ListItem>
              <ListItem sx={{ gap: 3 }} disableGutters>
                <Typography
                  className="legend-label letter"
                  sx={{ color: '#2C3E50' }}
                >
                  U
                </Typography>
                <Typography className="legend-label">Única</Typography>
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Popover>
  );
};

export default MoreInfoDialog;
